import * as React from 'react';
import { FC } from 'react';

import { Box } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import Modal from 'components/modal';

import { Body, Header, ItemText, StyledPicture } from './modal-item-unavailable.styled';
import { IModalItemUnavailableViewProps } from './types';

export const ModalItemUnavailableView: FC<React.PropsWithChildren<
  IModalItemUnavailableViewProps
>> = ({
  handleContinue,
  handleChangeStore,
  unavailableItemName,
  header,
  image,
  selectNewBtnText,
  continueBtnText,
  body,
  imageAlt,
  hideSelectNewBtn,
}) => (
  <Modal
    amplitudeEventData={{
      modalAppearanceEventMessage: 'Static menu item unavailable',
    }}
    testID="item-unavailable-static-menu"
    allowsDismiss={false}
  >
    <Header>{header}</Header>
    <Body>{body}</Body>
    <StyledPicture alt={imageAlt} image={image} />
    <ItemText>{unavailableItemName}</ItemText>
    <Box flexDirection="column" margin={`32px 0 0`}>
      <Box width="100%" justifyContent="center" alignItems="center" margin="0 0 1rem">
        <ActionButton fullWidth onPress={handleContinue}>
          {continueBtnText}
        </ActionButton>
      </Box>
      {!hideSelectNewBtn && (
        <Box width="100%" justifyContent="center" alignItems="center" margin="0">
          <ActionButton
            fullWidth
            variant={ActionButtonVariants.OUTLINE}
            onPress={handleChangeStore}
          >
            {selectNewBtnText}
          </ActionButton>
        </Box>
      )}
    </Box>
  </Modal>
);
